import { localStorageService, StorageKeys } from '@ibk/shared-utils';
export function saveAccountId(data, companyId) {
    const selectedCompany = data?.find(item => item.targetId === companyId || item.entity?.id === companyId);
    if (selectedCompany?.account?.id) {
        localStorageService.setItemSync(StorageKeys.AccountId, selectedCompany.account.id);
        return true;
    }
    clearAccountId();
    return false;
}
export function updateAccountId(account) {
    if (account.accountId) {
        localStorageService.setItemSync(StorageKeys.AccountId, account.accountId);
    }
    else {
        clearAccountId();
    }
}
export function getAccountId() {
    return localStorageService.getItemSync(StorageKeys.AccountId);
}
export function clearAccountId() {
    localStorageService.removeItem(StorageKeys.AccountId);
}
export function hasAccountId() {
    return getAccountId() !== null;
}
export function getAccountInfo() {
    const accountId = getAccountId();
    if (accountId) {
        return {
            accountId,
            hasAccount: true,
        };
    }
    return {
        accountId: null,
        hasAccount: false,
    };
}
export function saveAllAccounts(data) {
    if (!data || data.length === 0) {
        clearAllAccounts();
        return 0;
    }
    const allCompanies = data
        .filter(item => item.entity?.id)
        .map(item => ({
        id: item.targetId,
        entityId: item.entity.id,
        entityType: item.entityType,
        partyId: item.entity.party?.id || null,
        authorizationOwnerPartyId: item.authorizationOwnerPartyId || null,
        accountId: item.account?.id || null,
        companyName: item.entity.companyName,
        firstName: item.entity.firstName,
        lastName: item.entity.lastName,
        tradingName: item.entity.tradingName,
        documentNumber: item.entity.documentNumber,
        accountRelationshipType: item.accountRelationshipType || null,
        bankCode: item.account?.bankCode || null,
        branchNumber: item.account?.branchNumber || null,
        accountNumber: item.account?.accountNumber || null,
        targetId: item.targetId,
    }));
    if (allCompanies.length > 0) {
        localStorageService.setItemSync(StorageKeys.AllAccounts, allCompanies);
    }
    else {
        clearAllAccounts();
    }
    return allCompanies.length;
}
export function getAllAccounts() {
    const accounts = localStorageService.getItemSync(StorageKeys.AllAccounts);
    return accounts || [];
}
export function clearAllAccounts() {
    localStorageService.removeItem(StorageKeys.AllAccounts);
}
export function hasAllAccounts() {
    const accounts = getAllAccounts();
    return accounts.length > 0;
}
export function findAccountByEntityId(entityId) {
    const accounts = getAllAccounts();
    return accounts.find(account => account.entityId === entityId) || null;
}
export function getAllAccountsInfo() {
    const accounts = getAllAccounts();
    return {
        accounts,
        count: accounts.length,
        hasAccounts: accounts.length > 0,
    };
}
export function getSelectedAccountInfo() {
    const accountId = getAccountId();
    const allAccounts = getAllAccounts();
    if (accountId) {
        const selectedAccount = allAccounts.find(account => account.accountId === accountId);
        if (selectedAccount) {
            return selectedAccount;
        }
    }
    try {
        const lastAccessedCompanyId = localStorage.getItem(StorageKeys.LastAccessedCompany);
        if (lastAccessedCompanyId) {
            const selectedAccount = allAccounts.find(account => account.id === lastAccessedCompanyId);
            if (selectedAccount) {
                return selectedAccount;
            }
        }
    }
    catch (error) {
        console.warn('Erro ao obter última empresa acessada:', error);
    }
    return allAccounts.length > 0 ? allAccounts[0] : null;
}
